<template>
  <div class="GoodListWrap">
    <BtnSearch :searchGoods="searchGoods" :middle="true"/>
    <div class="ListSelection">
      <div class="ListSelectionItem">
        <p :class="active== 0 ? 'active':''" @click="sortChange(0,'all')">综合</p>
      </div>
      <div class="ListSelectionItem">
        <p :class="active== 1 ? 'active':''" @click="sortChange(1,'sales')">销量</p>
      </div>
      <div class="ListSelectionItem">
        <p :class="active== 2 ? 'active':''" @click="sortChange(2,'price')">价格</p>
        <div class="IconGroup">
          <i class="iconfont icon-shang-copy" :class="active== 2&&sortPrice ? 'active':''"/>
          <i class="iconfont icon-shang" :class="active== 2&&!sortPrice ? 'active':''"/>
        </div>
      </div>
    </div>
    <div class="ListBodyWrap animated fadeInUp">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="load()">
        <ListGoods :list="list"/>
      </van-list>
    </div>
  </div>
</template>
<script>
import BtnSearch from "@/components/BtnSearch.vue";
import ListGoods from "@/components/ListGoods.vue";
import { GetGoodList } from "../../apis/https.js";
import { List } from "vant";
import Vue from "vue";
Vue.use(List);
export default {
  components: {
    BtnSearch,
    ListGoods
  },
  data() {
    return {
      id: "",
      searchName: "",
      list: [],
      active: 0,
      page: 1,
      loading: false,
      finished: false,
      sortPrice: false
    };
  },
  computed: {
    liststyle: function() {
      return this.$store.state.system.listStyle;
    }
  },
  created() {},
  mounted() {},
  activated() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    if (
      this.id != this.$route.query.id ||
      this.searchName != this.$route.query.searchName ||
      this.tagName != this.$route.query.tags
    ) {
      this.$toast.loading({
        duration: 0,
        loadingType: "spinner",
        message: "加载中"
      });
      this.id = this.$route.query.id || 0;
      this.searchName = this.$route.query.searchName || "";
      this.tagName = this.$route.query.tags || "";
      this.GetList(
        this.searchName,
        "all",
        this.id,
        false,
        1,
        this.tagName
      );
    }
  },
  methods: {
    //   关键字,排序规则,分类id,价格是否排序,页数,标签
    GetList(search, sortType, category_id, sortPrice, page, tags) {
      GetGoodList(search, sortType, category_id, sortPrice, page, tags)
        .then(res => {
          this.$toast.clear();
          this.loading = false;
          let arr = res.data.list.data;
          let result = new Array();
          if (res.data.list.current_page == res.data.list.last_page) {
            this.finished = true;
          }
          for (let i in arr) {
            if (arr[i].image != null) {
              result.push({
                goodsid: arr[i].goods_id,
                name: arr[i].goods_name,
                img: arr[i].image[0].file_path,
                price: arr[i].sku[0].goods_price
              });
            }
          }
          this.list = result;
        })
        .catch(e => {});
    },
    addList(search, sortType, category_id, sortPrice, page, tags) {
      GetGoodList(search, sortType, category_id, sortPrice, page, tags)
        .then(res => {
          this.$toast.clear();
          this.loading = false;
          let arr = res.data.list.data;
          if (res.data.list.current_page == res.data.list.last_page) {
            this.finished = true;
          }
          for (let i in arr) {
            if (arr[i].image != null) {
              this.list.push({
                goodsid: arr[i].goods_id,
                name: arr[i].goods_name,
                img: arr[i].image[0].file_path,
                price: arr[i].sku[0].goods_price
              });
            }
          }
        })
        .catch(e => {});
    },
    sortChange(active, stype) {
      if (active != this.active) {
        this.active = active;
        this.GetList(this.searchName, stype, this.id, this.sortPrice, 1, "");
      } else if (active == 2) {
        this.sortPrice = !this.sortPrice;
        this.GetList(this.searchName, stype, this.id, this.sortPrice,  1, "");
      }
    },
    load() {
      this.page = this.page + 1;
      this.addList(
        this.searchName,
        "all",
        this.id,
        false,
        this.page,
        this.tagName
      );
    },
    searchGoods() {
      this.$router.push("/pages/search/index");
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.GoodListWrap {
  min-height: 100vh;
  background: #f7f7f7;
}
.ListSelection {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #eee;
  background: #fff;
  .ListSelectionItem {
    width: 33.33%;
    text-align: center;
    vertical-align: top;
    overflow: hidden;
    padding: 10px 0px;
    font-size: 14px;
    height: 40px;
    line-height: 20px;
    vertical-align: top;
    justify-content: center;
    display: flex;
    .active {
      color: @btn;
    }
    .IconGroup {
      margin-left: 3px;
      vertical-align: top;
      i {
        display: block;
        font-size: 7px;
        line-height: 10px;
      }
      .active {
        color: @btn;
      }
    }
  }
}
.ListBodyWrap {
  width: 100%;
}
</style>